import React from 'react';
import { usePIM } from '../../context/PIMContext';
import { Pallet3DVisualizer } from './Pallet3DVisualizer'; // Ensure imported
import { InnerPackVisualizer } from './InnerPackVisualizer';
import { Pallet2DVisualizer } from './Pallet2DVisualizer'; // Support 2D toggling

export const PalletFlipContainer = () => {
    const {
        isInnerPackMode,
        selectedPalletArrangement,
        palletMiddleWidget,
        innerPackCalculationResult
    } = usePIM();

    const is2D = palletMiddleWidget === 'Pallet2DVisualizer';

    return (
        <div className="w-full h-full perspective-1000">
            <div
                className={`relative w-full h-full duration-700 transform-style-3d transition-all ${isInnerPackMode ? 'rotate-y-180' : ''}`}
            >
                {/* FRONT FACE: Pallet Visualization */}
                <div className="absolute w-full h-full backface-hidden">
                    {/* Render 2D or 3D based on sub-selection */}
                    {is2D ? (
                        <div className="w-full h-full flex flex-col items-center justify-center bg-stone-900 border border-stone-700 rounded-lg p-4">
                            {selectedPalletArrangement ? (
                                <Pallet2DVisualizer arrangement={selectedPalletArrangement} />
                            ) : (
                                <div className="text-stone-500">No calculation results yet.</div>
                            )}
                        </div>
                    ) : (
                        <div className="w-full h-full bg-stone-900 border border-stone-700 rounded-lg overflow-hidden">
                            {selectedPalletArrangement ? (
                                <Pallet3DVisualizer arrangement={selectedPalletArrangement} />
                            ) : (
                                // Show placeholder or empty canvas
                                <div className="flex items-center justify-center h-full text-stone-500">
                                    Run a calculation to see visualization
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* BACK FACE: Inner Pack Visualization */}
                <div className="absolute w-full h-full backface-hidden rotate-y-180 bg-stone-900 border border-stone-700 rounded-lg overflow-hidden">
                    {innerPackCalculationResult ? (
                        <InnerPackVisualizer result={innerPackCalculationResult} />
                    ) : (
                        <div className="flex items-center justify-center h-full text-stone-500">
                            Run Inner Pack calculation to see visualization
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
